import { EFaceElements } from "../../Meshes/EFaceElements";
import { EMaterialSlot } from "../../Meshes/EMaterialSlot";

export class CabinetBoxFace {
    /**
     * The parts which are present on the face
     */
    public elements: EFaceElements;

    /**
     * The material of the front face
     */
    public material: EMaterialSlot;

    /**
     * The corresponding index as seen in the ShapeType static data,
     * -1 for fake faces
     */
    public readonly faceIndex: number;

    constructor(elements: EFaceElements, material: EMaterialSlot, faceIndex: number) {
        this.elements = elements;
        this.material = material;
        this.faceIndex = faceIndex;
    }
}